module.exports = __webpack_public_path__ + "img/f4.9d89527e.png";